export const isProtected = (route) => {
  const unprotectedRoutes = [
    '/accountLinked',
    '/auth/thankYou',
    '/auth/login',
    '/auth/signup',
    '/auth/google',
    '/home',
    '/welcome',
    '/zoomTag',
    '/zoom/connect',
    '/zoom-app',
    '/zoom-app/meeting',
    '/zoom-app/login',
    '/zoom-app/signup',
    '/zoom-app/landing',
    '/login',
    '/signup',
    '/transient',
    '/ipa/events/[slug]',
    '/my-teams/invitations/[id]',
    '/streams/[streamId]/overview',
    '/streams/[streamId]/linkLibrary',
    '/headless/login/[token]',
    '/l/choice-circle',
    '/l/emojis-everywhere',
    '/l/fantastic-fans',
    '/l/link-library',
    '/l/magic-maps',
    '/l/quick-questions',
    '/l/rating-polls',
    '/l/talking-tiles',
    '/l/text-track',
    '/l/transient-thoughts',
    '/l/winning-wheel',
    '/l/wonder-words',
    '/l/power-polls/[id]/[slug]',
    '/l/open-ended-polls',
    '/s/[stream_id]',
    '/share/[stream_id]/[screenshot_id]',
    '/l1/[link_id]',
    '/embed/gamma',
    '/embed/[org]/library',
    '/embed/[org]/connect',
    '/embed/backstagepass/library',
    '/embed/backstagepass/connect',
    '/connect-to-stream',
    '/entry/powerpoint',
    '/debug/powerpoint',
    '/sessions/qr-code'
  ];

  return !unprotectedRoutes.includes(route);
};

export const guestModeAllowed = (route) => {
  const guestModeRoutes = ['/streams/[streamId]/ros', '/zoom-app', '/zoom-app/meeting', '/zoom-app/landing', '/accessibility', '/sandbox'];
  return guestModeRoutes.includes(route);
};

export const isCopilotRoute = (route) => {
  const copilotRoutes = ['/ipa/events/:event_id', '/streams/[streamId]/ros'];
  return copilotRoutes.includes(route);
};

export const isAdminRoute = (route) => {
  const adminRoutes = ['/admin/dashboard'];

  return adminRoutes.includes(route);
};
